module.exports = __webpack_public_path__ + "static/media/calendarActive.6bdf2797.svg";